/**
 * Code from Vue 2 mixin now in a Vue 3 composable.
 *
 * @author cm359n
 */
export const useTimetableMethods = () => {

    const campusIndicatorDiv = (props) => {
        let ret = document.createElement('div')
        ret.setAttribute('class', 'timetable-campus-indicator')
        let place = ''
        if (props.classif == 'ONANY' || props.classif == 'ONLIVE') {
            place = 'Off Campus'
        } else if (props.classif == 'TBA') {
            place = 'To Be Advised'
        } else {
            place = 'On Campus'
        }

        const location = humanify(props.classif)
        if (props.classif == 'TBA') {
            ret.innerHTML = place
        } else if (location == 'Online Anytime' || location == 'Online Live') {
            ret.innerHTML = place + ' - ' + location
        } else {
            ret.innerHTML = place
        }
        return ret
    }

    const eventType = () => {
        return 'Event'
        // WCSC-571 to fix later FIXME
        // if (ev == 'ONANY' || ev == 'ONLIVE') {
        //  return 'Event - OFF CAMPUS'
        /// } else {
        //  return 'Event - ON CAMPUS'
        // }
    }

    const expandDetailsDiv = (props, icons) => {
        let ret = document.createElement('div')
        ret.setAttribute('class', 'timetable-detail')
        let hdDiv = document.createElement('div')
        hdDiv.setAttribute('class', 'timetable-detail-hide')

        // DETAILS div contains...
        let hasHiddenContent = false
        // class type (if there)
        // lecturer (if there)
        // actual details from event
        const detailFields = ['classType', 'lecturer', 'details']
        detailFields.forEach((fieldname) => {
            const hiddenText = props[fieldname]
            if (typeof hiddenText !== 'undefined') {
                hdDiv.appendChild(pElem(hiddenText))
                hasHiddenContent = true
            }
        })

        let iconDiv = document.createElement('div')
        iconDiv.setAttribute('class', 'timetable-detail-arrow')
        if (hasHiddenContent) {
            let icon = document.createElement('img')
            icon.setAttribute('alt', 'show/hide class detail')
            icon.setAttribute('src', icons['expandChev'])
            iconDiv.appendChild(icon)
        }

        ret.appendChild(hdDiv)
        ret.appendChild(iconDiv)
        return ret
    }

    const formatDetails = (dets, zoomLink_ref, otherDetails_ref) => {
        zoomLink_ref.value = null
        otherDetails_ref.value = null

        if (dets != null) {
            let zoomMatch = dets.match(/(https:\/\/uofglasgow\.zoom\.us\/\S+)/)
            if (zoomMatch) {
                zoomLink_ref.value = zoomMatch[0]
                dets = dets.replace(zoomMatch[0], '')
            }
            if (dets != '') {
                otherDetails_ref.value = dets
            }
        }
    }

    // Replaces blanks with standard contact message.
    const formatText = (text) => {
        if (text == null || text === '') {
            text = 'Contact school for info'
        }
        return text
    }

    const getBuildingId = (roomId) => {
        if (roomId) {
            return roomId.substring(0, 3)
        }
    }

    const getPlace = (props) => {
        const classif = props.classif

        let ret = 'On Campus'
        if (classif == 'ONANY' || classif == 'ONLIVE') {
            ret = 'Off Campus'
        } else if (classif == 'TBA') {
            ret = 'To Be Advised'
        }
        return ret
    }

    const humanify = (location) => {
        if (location == 'ONANY') {
            return 'Online Anytime'
        } else if (location == 'ONLIVE') {
            return 'Online Live'
        } else {
            return location
        }
    }

    const iconEl = (src, alt) => {
        let ret = document.createElement('img')
        ret.setAttribute('src', src)
        ret.setAttribute('alt', alt)
        return ret
    }

    const iconSpan = (props, icons) => { /* icon for event item */
        const classif = props.classif

        let iconSpan = document.createElement('span')
        let icon
        // icons
        const anytimeIcon = icons['anytime']
        const liveIcon = icons['live']
        const roomedIcon = icons['roomed']
        const bookingIcon = icons['booking']

        if (props.isUserBooking) {
            icon = iconEl(bookingIcon, 'Booking')
        } else if (classif == 'ONANY') {
            icon = iconEl(anytimeIcon, 'Online Anytime Event')
        } else if (classif == 'ONLIVE') {
            icon = iconEl(liveIcon, 'Online Live Event')
        } else {
            icon = iconEl(roomedIcon, 'On Campus Event')
        }
        iconSpan.setAttribute('class', 'eventIcon')
        iconSpan.appendChild(icon)
        return iconSpan
    }

    const linkToMaps = (roomid, roomgrpcode) => {
        var door = roomgrpcode || roomid
        return '#/map?buildingId=' + getBuildingId(door) + '&toId=' + door + '&toType=R'
    }

    const listviewDescriptionElem = (props, fallback, icons) => {
        // creates the layout in list view to add to the element in FullCalendar.
        /*
           [icon] [class title]
           [pin icon] [location]
           [what type of class - ONLIVE/ONANY etc]
           [details]
        */
        let ret
        if (typeof props !== 'undefined') {
            // user booking
            if (props.isUserBooking) {
                let dispTitle = fallback
                if (typeof dispTitle === 'undefined' || dispTitle == 'null') {
                    dispTitle = '(no title)'
                }
                ret = document.createElement('div')
                let fbElem = document.createElement('div')
                let fbSpan = document.createElement('span')
                let fbText = document.createTextNode(dispTitle)
                fbSpan.appendChild(fbText)
                fbElem.appendChild(iconSpan(props, icons))
                fbElem.appendChild(fbSpan)
                ret.appendChild(fbElem)
                ret.appendChild(locationSpan(props, icons))
            }
            // teaching event
            if (props.course) {
                ret = document.createElement('div')
                let fbElem = document.createElement('div')
                let fbSpan = document.createElement('span')
                let fbText = document.createTextNode(props.course)
                fbSpan.appendChild(fbText)
                fbElem.appendChild(iconSpan(props, icons))
                fbElem.appendChild(fbSpan)
                ret.appendChild(fbElem)
                ret.appendChild(locationSpan(props, icons))
            }
        }
        return ret
    }

    const locationSpan = (props, icons) => { /* contains location and link to map */
        // left cell
        const classif = props.classif
        const useMoodleIcon = (classif == 'ONLIVE' || classif == 'ONANY') && !props.room
        const icon = useMoodleIcon
            ? iconEl(icons['moodle'])
            : iconEl(icons['location'], 'Location')

        // right cell
        let fbDiv = document.createElement('div')
        if (!useMoodleIcon) {
            let fbElem = document.createElement('a')
            if (props.room) {
                fbElem.setAttribute('class', 'purpleLink')
                fbElem.setAttribute('href', linkToMaps(props.roomid, props.roomgrpcode))
                fbElem.innerText = (props.room ? props.room : 'Contact school for location')
                fbDiv.appendChild(fbElem)
            }
        } else if (classif == 'ONLIVE' || classif == 'ONANY') {
            let fbElem = document.createElement('a')
            fbElem.setAttribute('class', 'purpleLink')
            // TODO: correct link AND ICON for moodle and only for online classes
            fbElem.setAttribute('href', 'https://moodle.gla.ac.uk/')
            fbElem.innerText = ('See Moodle')
            fbDiv.appendChild(fbElem)
        } else {
            fbDiv.appendChild(pElem('Contact school for location'))
        }
        if (!props.isUserBooking) {
            fbDiv.appendChild(campusIndicatorDiv(props))
        }
        if (props.course) {
            fbDiv.appendChild(expandDetailsDiv(props, icons))
        }
        // return span with table with both cells
        let ret = document.createElement('span')
        ret.appendChild(LRTableOf(icon, fbDiv))
        return ret
    }

    const LRTableOf = (...rowOfElements) => {
        // table of: stuff[0] | stuff[1] | stuff[2] etc
        let ret = document.createElement('table')
        ret.setAttribute('class', 'timetable-loc-display')
        let tbody = document.createElement('tbody')
        let tr = document.createElement('tr')
        for (let tdData of rowOfElements) {
            let td = document.createElement('td')
            td.appendChild(tdData)
            tr.appendChild(td)
        }
        tbody.appendChild(tr)
        ret.appendChild(tbody)
        return ret
    }

    const pElem = (text) => {
        let ret = document.createElement('p')
        let textEl = document.createTextNode(text)
        ret.appendChild(textEl)
        return ret
    }

    const toggleExpandDiv = (info) => {
        const expandNode = info.el.querySelector('.timetable-detail')
        if (expandNode) {
            // let hidden = true
            if (expandNode.childNodes[0].classList.contains('timetable-detail-hide')) {
                // hidden = false
                expandNode.childNodes[0].classList.remove('timetable-detail-hide')
                expandNode.childNodes[0].classList.add('timetable-detail-show')
                expandNode.childNodes[1].classList.add('rotateChev')
            } else {
                expandNode.childNodes[0].classList.remove('timetable-detail-show')
                expandNode.childNodes[0].classList.add('timetable-detail-hide')
                expandNode.childNodes[1].classList.remove('rotateChev')
            }
        }
    }

    return {
        eventType,
        formatDetails,
        formatText,
        getBuildingId,
        getPlace,
        humanify,
        linkToMaps,
        listviewDescriptionElem,
        toggleExpandDiv
    }
}